const state = {
  list: [
    { name: "Energia elettrica", code: "EE", mu: "kWh", thermal: false },
    { name: "Gas naturale", code: "gas", mu: "Sm³", thermal: true },
    { name: "Fluido termovettore", code: "fluidth", mu: "kWh th", thermal: false },
    { name: "Olio combustibile", code: "olioc", mu: "l", thermal: false },
    { name: "Temperatura", code: "t", mu: "°C", thermal: false },
    { name: "GPL", code: "GPL", mu: "l", thermal: false },
    { name: "Gasolio", code: "Diesel", mu: "l", thermal: false },
    { name: "CDR", code: "CDR", mu: "l", thermal: false },
    { name: "Scarti processo lavorazione legno", code: "spll", mu: "t", thermal: false },
    { name: "Benzine", code: "benz", mu: "l", thermal: false },
    { name: "Acqua", code: "water", mu: "m³", thermal: false },
    { name: "Kerosene Jet Fuel", code: "KJF", mu: "l", thermal: false },
    { name: "Vapore", code: "steam", mu: "kg", thermal: true },
    { name: "Aria compressa", code: "air", mu: "Sm³", thermal: false },
  ],
}

const getters = {
  getMu: (state) => (code) => {
    let vector = _.find(state.list, v => v.code == code)
    return vector ? vector.mu : ""
  },
  getName: (state) => (code) => {
    let vector = state.list.find(v => v.code === code);
    return vector ? vector.name : code;
  },
  getMuByName: (state) => (name) => {
    let vector = state.list.find(v => v.name === name);
    return vector ? vector.mu : "";
  }
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/vectors.js